import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {InactiveOrderReminderRepositoryInstance} from "../../repository/Order/InactiveOrderReminderRepository";
import {
    DealershipExcludedRequest,
    ProductExcludedRequest,
    SaveInactiveOrderReminderSettings,
    SendInactiveOrderReminderBatch,
} from "../../shared/entities/Order/InactiveOrderReminder";

export class InactiveOrderReminderService {
    private dispatch: Dispatch<PayloadAction<unknown>>;
    private repository = InactiveOrderReminderRepositoryInstance;

    constructor(dispatch: Dispatch<PayloadAction<unknown>>) {
        this.dispatch = dispatch;
    }

    public async list(params: Record<string, unknown>) {
        return this.repository.list(params).then(res => res.Some);
    }

    public async pendingCount(params: Record<string, unknown>) {
        return this.repository.pendingCount(params).then(res => res.Some);
    }

    public async recipients(dealershipId: number) {
        return this.repository.recipients(dealershipId).then(res => res.Some);
    }

    public async send(data: SendInactiveOrderReminderBatch) {
        return this.repository.send(data).then(res => res);
    }

    public async settings(dealershipIds: number[]) {
        return this.repository.settings(dealershipIds).then(res => res.Some);
    }

    public async saveSettings(data: SaveInactiveOrderReminderSettings) {
        return this.repository.saveSettings(data).then(res => res);
    }

    public async setDealershipExcluded(data: DealershipExcludedRequest) {
        return this.repository.setDealershipExcluded(data).then(res => res);
    }

    public async setProductExcluded(data: ProductExcludedRequest) {
        return this.repository.setProductExcluded(data).then(res => res);
    }
}
